import { render, staticRenderFns } from "./LoginFooter.vue?vue&type=template&id=6dd953c6&"
import script from "YD/components/speedTest/FooterSpeedTest.component?vue&type=script&lang=js&"
export * from "YD/components/speedTest/FooterSpeedTest.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports